import usdt from "./usdt/usdt";
import busd from "./busd/busd"
const tokensBSC = {
    usdt,busd
}

export default tokensBSC